import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { capitalGainsSelector } from '../selectors'
import { handleRequestError } from './request'
import { updateAndSaveActiveTaxReturn } from './tax-return'

export const REQUEST_CAPITAL_GAINS_SUMMARY = 'REQUEST_CAPITAL_GAINS_SUMMARY'
export const RECEIVE_CAPITAL_GAINS_SUMMARY = 'RECEIVE_CAPITAL_GAINS_SUMMARY'
export const SAVE_CAPITAL_GAINS_SUMMARY = 'SAVE_CAPITAL_GAINS_SUMMARY'
const CREATE_CAPITAL_GAINS_SUMMARY = 'CREATE_CAPITAL_GAINS_SUMMARY'

export const requestCapitalGainsSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_CAPITAL_GAINS_SUMMARY, data: { taxReturnId } })

    axios
        .get(`/capitalgainssummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveCapitalGainsSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveCapitalGainsSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveCapitalGainsSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveCapitalGainsSummary = (data) => ({ type: RECEIVE_CAPITAL_GAINS_SUMMARY, data })

const saveCapitalGainsSummary = (data) => (dispatch) => {
    dispatch({ type: SAVE_CAPITAL_GAINS_SUMMARY, data })

    const { taxReturnId } = data

    return axios
        .put(`/capitalgainssummaries/${taxReturnId}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveCapitalGainsSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveCapitalGainsSummary = (data) => (dispatch, getState) => {
    const { capitalGainsSummary } = capitalGainsSelector(getState())
    const updatedCapitalGainsSummary = { ...capitalGainsSummary, ...data }

    dispatch(receiveCapitalGainsSummary(updatedCapitalGainsSummary))
    return dispatch(saveCapitalGainsSummary(updatedCapitalGainsSummary)).catch(() => {})
}

export const updateAndSaveCapitalGainsSummaryStatus =
    ({ status }) =>
    (dispatch, getState) => {
        const { capitalGainsSummary } = capitalGainsSelector(getState())
        const updatedCapitalGainsSummary = { ...capitalGainsSummary, status }

        dispatch(receiveCapitalGainsSummary(updatedCapitalGainsSummary))
        return dispatch(saveCapitalGainsSummary(updatedCapitalGainsSummary))
            .then(() => dispatch(updateAndSaveActiveTaxReturn({ capitalGainsSummaryStatus: status })))
            .catch(() => {})
    }

export const createCapitalGainsSummary =
    (data = {}) =>
    (dispatch, getState) => {
        const { id } = getState().taxReturn

        dispatch({ type: CREATE_CAPITAL_GAINS_SUMMARY })

        return axios
            .put(`/capitalgainssummaries/${id}`, data)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receiveCapitalGainsSummary(responseData))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const createOrUpdateCapitalGainsSummary = (data) => (dispatch, getState) => {
    const { capitalGainsSummary, hasCapitalGainsSummary } = capitalGainsSelector(getState())

    const persist = hasCapitalGainsSummary ? updateAndSaveCapitalGainsSummary : createCapitalGainsSummary
    return dispatch(persist({ ...capitalGainsSummary, ...data }))
}
